import { render, staticRenderFns } from "./reformCatalogDetailPage.vue?vue&type=template&id=23385ccd&scoped=true"
import script from "./reformCatalogDetailPage.vue?vue&type=script&lang=js"
export * from "./reformCatalogDetailPage.vue?vue&type=script&lang=js"
import style0 from "./reformCatalogDetailPage.vue?vue&type=style&index=0&id=23385ccd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23385ccd",
  null
  
)

export default component.exports